import React from 'react';

const NoValue = () => <span className='NoValue'>No value</span>

export default NoValue;


// WEBPACK FOOTER //
// ./src/modules/form/components/NoValue.jsx